<template>
  <v-dialog
    v-model="editCustomerModal"
    persistent
    max-width="900px"
  >
    <v-card>
      <form
        action=""
        @submit.prevent="submitForm"
      >
        <v-card-title style="padding-bottom: 0px">
          <v-flex
            xs11
            sm11
            md11
          ><span class="headline">Update Customer</span></v-flex>
          <v-flex
            xs1
            sm1
            md1
          >
            <v-btn
              flat
              @click="closeEditCustomerModal(), $validator.reset()"
              class="close"
            >
              <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Customer Name"
                v-model="editCustomerData.full_name"
                :error-messages="errors.collect('Customer Name')"
                v-validate="'required'"
                data-vv-name="Customer Name"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Email"
                v-model="editCustomerData.email"
                :error-messages="errors.collect('email')"
                v-validate="'email'"
                data-vv-name="email"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Phone Number"
                v-model="editCustomerData.phone_number"
                :error-messages="errors.collect('phone_number')"
                v-validate="'required'"
                data-vv-name="phone_number"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Phone Number 2"
                v-model="editCustomerData.phone_number_2"
                :error-messages="errors.collect('Phone Number 2')"
                data-vv-name="Phone Number 2"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              class="px-2"
              xs12
              sm6
              md6
            >
              <v-select
                autocomplete
                :items="citiesList"
                item-value="city_id"
                item-text="city_name"
                v-model="editCustomerData.city_id_fk"
                :error-messages="errors.collect('City')"
                data-vv-name="City"
                label="City"
                clearable
              >
              </v-select>
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Address"
                v-model="editCustomerData.address"
                data-vv-name="address"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Price per wight (USA)"
                v-model.number="editCustomerData.item_weight_price_usa"
                data-vv-name="Price per wight (USA)"
                :error-messages="errors.collect('Price per wight (USA)')"
                v-validate="'required|decimal:2'"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Price per wight (Turkey)"
                v-model.number="editCustomerData.item_weight_price_turkey"
                data-vv-name="Price per wight (Turkey)"
                :error-messages="errors.collect('Price per wight (Turkey)')"
                v-validate="'required|decimal:2'"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Base Quantity Charge (Turkey)"
                v-model.number="editCustomerData.quantity_charge_base_turkey"
                data-vv-name="Base Quantity Charge (Turkey)"
                :error-messages="errors.collect('Base Quantity Charge (Turkey)')"
                v-validate="'required|decimal:2'"
              >
              </v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Other Quantity Charge (Turkey)"
                v-model.number="editCustomerData.quantity_charge_other_turkey"
                data-vv-name="Other Quantity Charge (Turkey)"
                :error-messages="errors.collect('Other Quantity Charge (Turkey)')"
                v-validate="'required|decimal:2'"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Base Quantity Charge (USA)"
                v-model.number="editCustomerData.quantity_charge_base_usa"
                data-vv-name="Base Quantity Charge (USA)"
                :error-messages="errors.collect('Base Quantity Charge (USA)')"
                v-validate="'required|decimal:2'"
              >
              </v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="Other Quantity Charge (USA)"
                v-model.number="editCustomerData.quantity_charge_other_usa"
                data-vv-name="Other Quantity Charge (USA)"
                :error-messages="errors.collect('Other Quantity Charge (USA)')"
                v-validate="'required|decimal:2'"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-text-field
                label="New Password"
                v-model.number="editCustomerData.new_password"
                data-vv-name="New Password"
                :error-messages="errors.collect('New Password')"
                v-validate="'min:6'"
              >
              </v-text-field>
            </v-flex>

            <v-flex
              v-if="!editCustomerData.base_phone_verified"
              xs12
              sm12
              md6
              class="px-2"
            >
              <v-checkbox
                v-model="editCustomerData.phone_verified"
                label="Verified"
                style="padding: 0px"
                :ripple="false"
              />
            </v-flex>
            <v-flex
              xs12
              sm10
              md12
              class="px-2"
            >
              <label
                for="description"
                style="opacity: 0.8; font-size: 14px; margin-bottom: -8px"
              >
                Customer Note
              </label>
              <textarea
                v-model="editCustomerData.customer_note"
                class="form-control"
                style="border-bottom: 1px solid blue; font-size: 1.5rem"
                rows="4"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="height:auto"
            @click="closeEditCustomerModal(), $validator.reset()"
            outline
            color="normal"
          >Cancel</v-btn>
          <v-btn
            type="submit"
            style="height:auto; margin-right: 2.5%"
            outline
            color="success"
          >Update</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: [
    'editCustomer',
    'editCustomerData',
    'editCustomerModal',
    'checkAlert',
    'closeEditCustomerModal',
    'emailError',
    'validationError',
    'backendError',
    'citiesList'
  ],

  methods: {
    submitForm(event) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.editCustomer()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/editCustomer.vue